import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import AuthShell, { Field, SubmitButton, ErrorNote } from "@/pages/Login";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset password"
      subtitle="We'll email you a link to choose a new password."
      footer={
        <Link to="/login" className="hover:text-foreground" data-testid="back-to-login">
          Back to sign in
        </Link>
      }
    >
      <form onSubmit={submit} data-testid="forgot-form">
        <ErrorNote message={error} />
        {message && (
          <div
            className="mb-4 px-3.5 py-2.5 rounded-md bg-pillar-health/20 text-foreground text-sm"
            data-testid="forgot-success"
          >
            {message}
          </div>
        )}
        <Field
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          data-testid="forgot-email"
        />
        <SubmitButton loading={loading} data-testid="forgot-submit">
          Send reset link
        </SubmitButton>
      </form>
    </AuthShell>
  );
}
